import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import ApiService from '../../../services/ApiService';

export const fetchAllWagonNumbers = createAsyncThunk(
  'wagonNumbers/fetchAllWagonNumbers',
  async () => {
    const wagonNumberList = await ApiService.getAllWagonNumbers();
    return wagonNumberList.data;
  },
);
export const fetchAllDamageCodes = createAsyncThunk(
  'damageCodes/fetchAllDamageCodes',
  async () => {
    const damageCodeList = await ApiService.getAllDamageCodes();
    return damageCodeList.data;
  },
);
export const ContentTabSlice = createSlice({
  name: 'contentTab',
  initialState: {
    ticketNumber: '',
    addTicket: false,
    editTicket: false,
    loading: false,
    wagonNumberList: [],
    damageCodes: {},
    drawerOpened: false,
    ticketMenuOpened: false,
    wagonMenuOpened: false,
    invoiceMenuOpened: false,
    analyticsMenuOpened: false,
    revisionPlanMenuOpened: false,
    selectedMenuTab: 'ticketList',
  },
  reducers: {
    setTicketNumber: (state, action) => {
      state.ticketNumber = action.payload;
    },
    setAddTicket: (state, action) => {
      state.addTicket = action.payload;
    },
    setEditTicket: (state, action) => {
      state.editTicket = action.payload;
    },
    setDrawerOpened: (state, action) => {
      state.drawerOpened = action.payload;
    },
    setTicketMenuOpened: (state, action) => {
      state.ticketMenuOpened = action.payload;
    },
    setWagonMenuOpened: (state, action) => {
      state.wagonMenuOpened = action.payload;
    },
    setInvoiceMenuOpened: (state, action) => {
      state.invoiceMenuOpened = action.payload;
    },
    setAnalyticsMenuOpened: (state, action) => {
      state.analyticsMenuOpened = action.payload;
    },
    setParametersMenuOpened: (state, action) => {
      state.parametersMenuOpened = action.payload;
    },
    setRevisionPlanMenuOpened: (state, action) => {
      state.revisionPlanMenuOpened = action.payload;
    },
    setTechnicalParametersMenuOpened: (state, action) => {
      state.technicalParametersMenuOpened = action.payload;
    },
    setForecastParametersMenuOpened: (state, action) => {
      state.forecastParametersMenuOpened = action.payload;
    },
    startLoading: (state) => {
      state.loading = true;
    },
    stopLoading: (state) => {
      state.loading = false;
    },
    setSelectedMenuTab: (state, action) => {
      state.selectedMenuTab = action.payload;
    },
  },
  extraReducers: {
    [fetchAllWagonNumbers.fulfilled]: (state, action) => {
      state.wagonNumberList = [];
      Array.prototype.forEach.call(action.payload, (wagonNumber) => {
        state.wagonNumberList.push(wagonNumber);
      });
    },
    [fetchAllDamageCodes.fulfilled]: (state, action) => {
      state.damageCodes = {};
      state.damageCodes = action.payload;
    },
  },
});
export const {
  setTicketNumber,
  setAddTicket,
  setEditTicket,
  startLoading,
  stopLoading,
  setDrawerOpened,
  setTicketMenuOpened,
  setWagonMenuOpened,
  setInvoiceMenuOpened,
  setSelectedMenuTab,
  setAnalyticsMenuOpened,
  setParametersMenuOpened,
  setRevisionPlanMenuOpened,
  setTechnicalParametersMenuOpened,
  setForecastParametersMenuOpened,
} = ContentTabSlice.actions;

export const ticketNumberState = (state) => state.contentTab.ticketNumber;
export const addTicketState = (state) => state.contentTab.addTicket;
export const editTicketState = (state) => state.contentTab.editTicket;
export const loadingState = (state) => state.contentTab.loading;
export const wagonNumberListState = (state) => state.contentTab.wagonNumberList;
export const damageCodesState = (state) => state.contentTab.damageCodes;
export const drawerOpenedState = (state) => state.contentTab.drawerOpened;
export const ticketMenuOpenedState = (state) =>
  state.contentTab.ticketMenuOpened;
export const wagonMenuOpenedState = (state) => state.contentTab.wagonMenuOpened;
export const invoiceMenuOpenedState = (state) =>
  state.contentTab.invoiceMenuOpened;
export const analyticsMenuOpenedState = (state) =>
  state.contentTab.analyticsMenuOpened;
export const selectedMenuTabState = (state) => state.contentTab.selectedMenuTab;
export const parametersMenuOpenedState = (state) =>
  state.contentTab.parametersMenuOpened;
export const revisionPlanMenuOpenedState = (state) =>
  state.contentTab.revisionPlanMenuOpened;
export const technicalParametersMenuOpenedState = (state) =>
  state.contentTab.technicalParametersMenuOpened;
export const forecastParametersMenuOpenedState = (state) =>
  state.contentTab.forecastParametersMenuOpened;
export default ContentTabSlice.reducer;
